

















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Mission extends Vue {
  @Prop() private msg!: string;
}
